import { UIService } from '~/services/service.ui';
export const sxToolbar = { height: UIService.TOOLBAR_SEARCH_HEIGHT, justifyContent: 'center', gap: 1 };
